var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-sort-menu.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") > 0 && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")) {
output += "\n\n<select\n    class=\"c-category-sort js-category-sort js-enable-preload-sorting dom-category-sort\"\n    aria-label=\"";
output += runtime.suppressValue((lineno = 7, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-label"])), env.opts.autoescape);
output += "\"\n    data-element-name=\"sort\"\n    data-cm-element=\"category_sort\"\n    data-qa-category-sort\n    >\n\n    <option value selected data-is-default=\"true\" data-qa-featured-sort>";
output += runtime.suppressValue((lineno = 13, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-label"])), env.opts.autoescape);
output += "</option>\n\n    ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"sortOptions")),"availableSorts");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("sortOption", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "<option data-sort-key=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"key"), env.opts.autoescape);
output += "\" data-ga-slug=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"cmSlug"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_4),"queryString")), env.opts.autoescape);
output += "\"";
if(runtime.memberLookup((t_4),"isSelected")) {
output += "\n                selected=\"selected\"";
;
}
output += "data-qa-sort=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"cmSlug"), env.opts.autoescape);
output += "\">\n            ";
output += runtime.suppressValue((lineno = 21, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_sort-" + "" + runtime.memberLookup((t_4),"key")])), env.opts.autoescape);
output += "\n        </option>";
;
}
}
frame = frame.pop();
output += "\n\n</select>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-sort-menu.j2"] , dependencies)